import {
  DataImportantStatusEnum,
  ENUM_USER_SHIPPING_STATUS,
  ENUM_USER_STATUS,
  IData,
  UserState,
} from "../types";

export const defaultFormData: IData = {
  _id: "",
  createdAt: "",
  updatedAt: "",
  status: ENUM_USER_STATUS.ACTIVE,
  email: "",
  firstName: "",
  lastName: "",
  japaneseFirstName: "",
  japaneseLastName: "",
  mobileNumber: "",
  password: "",
  confirmPassword: "",
  streetAddress: "",
  postCode: "",
  prefectures: "",
  companyName: "",
  importantStatus: DataImportantStatusEnum.Null,

};

export const initialState: UserState = {
  formData: { ...defaultFormData },
  list: [],
  loading: false,
  buttonLoading: false,
  toggleLoading: false,
  search: "",
  pageNo: 1,
  pageSize: 30,
  totalRow: 0,
  orderBy: "",
  orderDir: "",
  orders: [],
  orderPageNo: 1,
  orderPageSize: 30,
  orderTotalRow: 0,
  endDate: null,
  startDate: null
};
